module.exports = __webpack_public_path__ + "static/media/data_analysis_logo.b1144026.png";